import firebase from 'firebase';

import View from '../../_components/view/view.js';
import roundsTpl from './rounds.tpl.html';
import './rounds.styles.less';

import groupsService from '../../_services/groups.service.js';
import playersService from '../../_services/players.service.js';
import matchesService from '../../_services/matches.service.js';
import ConfirmModal from '../../_modals/confirm-modal/confirm-modal.view.js';
import CompleteGroupView from '../../_components/complete-group/complete-group.view.js';

class SectionsBarView extends View {

	constructor (data, options) {
		super(roundsTpl, data, _.extend(options, {
				viewClass: 'rounds'
			})
		);
	}

	uiElements() {
		return _.extend(super.uiElements(), {
			activeContainer: '.active-container',
			activeRoundContainer: '.active-round-container',
			inactiveContainer: '.inactive-container',
			colEndRound: '.col-end-round',
			btnBlockRound: '.btn-block-round',
			btnUnblockRound: '.btn-unblock-round',
			btnEndRound: '.btn-end-round',
			btnGenerateRound: '.btn-generate-round',
			inputDoPromotions: 'input[name="players-promotions-checkbox"]'
		});
	}

	render(data) {
		super.render(data);

	}

	initializeEvents() {
		//UI Events
		this.ui.btnEndRound.click(() => this.endCurrentRound());
		this.ui.btnGenerateRound.click(() => this.generateNewRound());
		this.ui.btnBlockRound.click(() => this.blockRound());
		this.ui.btnUnblockRound.click(() => this.unblockRound());

		///Database Events
		firebase.auth().onAuthStateChanged( user => {
			this.user = user;
			this.updateView();
		});

		firebase.database().ref('/matches').on('value', __matches => {
			this.__matches = __matches;
			this.updateView();
		});
		firebase.database().ref('/groups').on('value', __groups => {
			this.__groups = __groups;
			this.updateView();
		});
		firebase.database().ref('/players').once('value', __players => {
			this.__players = __players;
			this.updateView();
		});

		firebase.database().ref('/currentRound/')
			.on('value', __currentRound => {
				this.__currentRound = __currentRound;
				this.roundActive = __currentRound.val().isActive;
				this.roundBlocked = __currentRound.val().isBlocked;
				this.updateRoundState();
			});
	}

	updateRoundState() {
		if (this.roundActive) {
			this.ui.activeContainer.removeClass('hidden');
			this.ui.activeRoundContainer.removeClass('hidden');
			this.ui.inactiveContainer.addClass('hidden');

			if (this.roundBlocked) {
				this.ui.colEndRound.addClass('hidden');
				this.ui.btnUnblockRound.removeClass('hidden');
				this.ui.btnBlockRound.addClass('hidden');
			} else {
				this.ui.colEndRound.removeClass('hidden');
				this.ui.btnUnblockRound.addClass('hidden');
				this.ui.btnBlockRound.removeClass('hidden');
			}
		} else {
			this.ui.inactiveContainer.removeClass('hidden');
			this.ui.activeContainer.addClass('hidden');
			this.ui.activeRoundContainer.addClass('hidden');
		}
	}

	updateView() {
		if (this.__matches && this.__groups && this.__players && this.user) {
			this.ui.activeRoundContainer.empty();
			
			this.__groups.forEach(__group => {
				let
				groupPlayers = _.pickBy(this.__players.val(), player => player.groupId === __group.key),
				groupPlayersArray = _.filter(
					playersService.toArrayWithIds(this.__players), 
					player => player.groupId === __group.key
				),
				groupMatches = _.filter(
					matchesService.toArrayWithIds(this.__matches), 
					match => match.groupId === __group.key
				),
				groupStandings  = groupsService.getGroupStandings(groupMatches, groupPlayersArray),

				completeGroupView = new CompleteGroupView(
					{
						players: groupPlayers,
						group: __group.val(),
						groupMatches: groupMatches,
						groupStandings: groupStandings,
						user: this.user
					}, {
						__group: this.__group,
						__matches: this.__matches,
						__players: this.__players
					}
				).appendTo(this.ui.activeRoundContainer);

			});
		}
	}


	generateNewRound() {
		//Open Confirmation Modal
		this.openConfirmGenerateNewRound()
		.then( confirm => {
			if (confirm) {
				//Block current round
				this.setInProcess()
				.then(() => {
					//Check if there are existing matches on the DB
					if (this.__matches.val()) {
						throw new Error('There are existing matches on the DB. Please clear those before creating a new Round');
					} else {
						//Generate the Round matches
						this.generateRoundMatches(this.__groups)
						.then((matches) => {
							//Set Round Matches in DB
							this.__matches.ref.set(matches)
							.then( result => {
								//Unblock round and make it active
								this.unsetInProcess(true)
								.then( () => {
									console.log('ROUND ACTIVE!');
								});
							});
						}).catch(error => this.generateRoundError(error));
					}
				}).catch(error => this.generateRoundError(error));
			}
		});
	}

	openConfirmGenerateNewRound() {
		return new ConfirmModal(
			`Are you sure you want to generate a new  round?<br>
			This action <strong>CANNOT be undone</strong> <br> <br>
			This action will create the matches between group players.
			Be sure that you have all groups filled with the players you want.
			`,
			'Confirm Generate Round'
		).open();
	}

	generateRoundError(error) {
		console.log('Error generating the round');
		console.error(error);
		this.unsetInProcess();
	}


	generateRoundMatches(__groups) {
		let 
		matchesArray = [];

		return firebase.database().ref('players/')
			.orderByChild('groupId')
			.startAt(true) //Gets all the values that don't have "null" or "false" in groupId. More info: https://firebase.google.com/docs/database/web/retrieve-data?hl=es#como_filtrar_datos
			.once('value').then(__players => {
				let 
				matchesArray = [];
				
				__groups.forEach( __group => {
					let 
					groupPlayers = _.filter(playersService.toArrayWithIds(__players), 
						player => player.groupId === __group.key
					);

					matchesArray = matchesArray.concat(
						groupsService.generateGroupMatches(
							__group.val(), 
							__group.key, 
							groupPlayers
						)
					);
				});

				return matchesArray;
			});
	}
	
	openConfirmEndCurrentRound() {
		return new ConfirmModal(
			`Are you sure you want to end the current round?<br>
			This action <strong>CANNOT be undone</strong> <br> <br>
			Also, be sure to <strong>check the checkbox under "End Round" button if you
			want players to be automatically promoted and demoted</strong>. <br>Otherwise
			you will need to do it yourself in the Groups panel
			`,
			'Confirm End Round'
		).open();
	}

	endCurrentRound() {
		let round = {};
		this.openConfirmEndCurrentRound().then( confirm => {
			if (confirm) {
				//Block current round
				this.setInProcess()
				.then(() => {
					//Get current round status
					round.matches = this.__matches.val();
					round.groups = this.__groups.val();
					round.saveDate = Date.now();

					_.forEach(round.groups, (group, key) => {
						group.players = _.pickBy(this.__players.val(), 
							player => player.groupId === key
						);
					});

					this.setRoundActive(false).then(() => {
						//TODO: Refactor this
						if (this.ui.inputDoPromotions.prop("checked") === true) {
								groupsService.doGroupsPromotions(this.__groups, this.__players, this.__matches)
									.then(() => {
										this.__matches.ref.remove().then( () => {
											//Unblock round
											this.unsetInProcess().then(() => {
												firebase.database().ref('/rounds').push(round);
												console.log('ROUND ENDED!');
											});
										});
									});
						} else {
							this.__matches.ref.remove().then( () => {
								//Unblock round
								this.unsetInProcess().then(() => {
									firebase.database().ref('/rounds').push(round);
									console.log('ROUND ENDED!');
								});
							});
						}
					});

				});
			}
		});
	}

	setRoundActive(active) {
		return this.__currentRound.ref.update({ isActive: active });
	}

	/**
	 * Sets round "in process" so no other user can process the
	 * round at same time.
	 * @throws {Error} If round is already in process
	 */
	setInProcess() {
		return this.__currentRound.ref.transaction( currentRound => {
			if (currentRound) {
				if (currentRound.inProcess) {
					throw new Error('The round is already in process');
				} else {
					currentRound.inProcess = true;
				}

				return currentRound;
			} else {
				return 0;
			}
		});
	}

	/**
	 * "Releases" the current round so other users can process it
	 */
	unsetInProcess(activate) {
		if (activate !== undefined) {
			return this.__currentRound.ref.update({isActive: activate, inProcess: false });
		} else {
			return this.__currentRound.ref.update({ inProcess: false });
		}
	}

	blockRound() {
		return this.__currentRound.ref.update({ isBlocked: true });
	}

	unblockRound() {
		return this.__currentRound.ref.update({ isBlocked: false });
	}

}

export default SectionsBarView;


// WEBPACK FOOTER //
// ./C:/Users/juanb/Dev/transforma-ping-pong-league/src/admin-section/rounds/rounds.view.js